module.exports = __webpack_public_path__ + "img/lunbo42.54bd29c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_img/lunbo42.png
// module id = 5QB/
// module chunks = 0